// extracted by mini-css-extract-plugin
export default {"page-size":"A4Us8JZgUxuC9OK","page-size-info":"tldclH7wj5KwGIT"};